import {
  BrandAndMarketListItem,
  BookingIdRemarkRuleOrderValue,
} from "../../../../integrated-client";
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_TOTAL_ITEMS,
} from "../../../../utils/Constants";

export interface IRemarksFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderByDescending?: boolean;
  orderValue?: BookingIdRemarkRuleOrderValue;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;
}

export class RemarksFiltersData implements IRemarksFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderByDescending?: boolean;
  orderValue?: BookingIdRemarkRuleOrderValue;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
